import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";
import { toast } from "sonner";

const AdminLogin = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      const data = await authApi.login(email, password);
      localStorage.setItem("rl_token", data.access_token);
      localStorage.setItem("rl_email", data.email);
      toast.success("Welcome back!");
      nav("/admin");
    } catch (e) {
      const detail = e?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Login failed";
      setErr(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-[#FAF6F0]">
      <div className="hidden md:block md:w-1/2 relative">
        <img
          src="https://images.unsplash.com/photo-1557062975-96113e46608b?w=1600&q=85"
          alt="Sacred"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-[#2a1005]/80 to-transparent" />
        <div className="absolute bottom-12 left-12 text-white max-w-md">
          <div className="text-[#D4AF37] text-xs tracking-[0.4em] uppercase mb-3">Admin Portal</div>
          <h1 className="font-serif text-5xl leading-tight">Manage Sacred Content</h1>
          <p className="mt-4 text-white/80 leading-relaxed">
            Update banners, pujas, products and settings from your private dashboard.
          </p>
        </div>
      </div>

      <div className="w-full md:w-1/2 flex items-center justify-center px-6 md:px-12">
        <div className="w-full max-w-md">
          <div
            className="w-14 h-14 rounded-full flex items-center justify-center text-[#FAF6F0] font-serif text-2xl mb-6"
            style={{
              background: "radial-gradient(circle at 30% 30%, #b46a2a, #6b2f0a 70%, #2a1005)",
            }}
          >
            ॐ
          </div>
          <h2 className="font-serif text-4xl text-[#2D2825]">Admin Login</h2>
          <p className="text-[#5C544F] mt-2">Sign in to manage your Rudralife website.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="block text-xs tracking-widest uppercase text-[#5C544F] mb-2">Email</label>
              <input
                data-testid={ADMIN.loginEmail}
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                className="w-full px-4 py-3 rounded-xl bg-white border border-[rgba(45,40,37,0.15)] focus:border-[#8B2323] focus:ring-2 focus:ring-[#8B2323]/10 outline-none transition"
                placeholder="admin@rudralife.com"
              />
            </div>
            <div>
              <label className="block text-xs tracking-widest uppercase text-[#5C544F] mb-2">Password</label>
              <input
                data-testid={ADMIN.loginPassword}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                className="w-full px-4 py-3 rounded-xl bg-white border border-[rgba(45,40,37,0.15)] focus:border-[#8B2323] focus:ring-2 focus:ring-[#8B2323]/10 outline-none transition"
                placeholder="••••••••"
              />
            </div>

            {err && <div className="text-sm text-[#D32F2F]">{err}</div>}

            <button
              type="submit"
              data-testid={ADMIN.loginSubmit}
              data-cursor="button"
              disabled={loading}
              className="w-full py-3.5 bg-[#8B2323] hover:bg-[#6B1A1A] text-white rounded-full text-sm tracking-[0.3em] uppercase transition-colors disabled:opacity-60"
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
